import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';


export interface KeyFigure {
  id: number;
  total_assets: number;
  active_clients: number;
  total_portfolio: number;
  number_of_offices: number;
  city_provinces: number;
  districts: number;
  month: number;
  monthName: string;
  year: number;
}

@Injectable({
  providedIn: 'root'
})

export class KeyFigureService {

  private apiUrl = environment.baseApiUrl;

  constructor(private http: HttpClient) { }


  // Convert month number to month name
  private convertMonthToName(month: number): string {
    const months: string[] = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return months[month - 1];  // Subtract 1 to match the 1-based index
  }

  private convertMonthToNameKhmer(month: number): string {
    const months: string[] = [
      'មករា', 'កុម្ភៈ', 'មីនា', 'មេសា', 'ឧសភា', 'មិថុនា',
      'កក្កដា', 'សីហា', 'កញ្ញា', 'តុលា', 'វិច្ឆិកា', 'ធ្នូ'
    ];
    return months[month - 1];
  }

  getLatestKeyFigure(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/key-figures/last-record`).pipe(
      map((response: any) => {
        if (response.data && response.data.month) {
          response.data.monthName = this.convertMonthToName(response.data.month); 
        }
        return response.data
      })
    );
  }

}
